import HomePageFooter from "../../components/HomePageFooter";
import HomePageHeader from "../../components/HomePageHeader";
import TransactionBlock from "../../components/TransactionBlock";
import styles from "./transactionpage.module.css";

export default function TransactionPage() {
  return (
    <div className={`container-fluid h-custom ${styles.page}`}>
      <div className={styles.header}>
        <HomePageHeader />
      </div>
      <div className={`row ${styles.transactionBlock}`}>
        <TransactionBlock />
      </div>
      <div className="row">
        <HomePageFooter />
      </div>
    </div>
  );
}
